{
  "testEnvironment": "Test environment",
  "currency": {
    "czk": "CZK",
    "eur": "€",
    "usd": "$"
  },
  "dashboardSidebarCollapse": {
    "expand": "Expand sidebar",
    "collapse": "Collapse sidebar"
  },
  "dashboardSidebarToggle": {
    "close": "Close sidebar",
    "open": "Open sidebar"
  },
  "navigation": {
    "dashboard": "My Tasks",
    "quotations": "Quotations",
    "workflows": "Workflows",
    "clients": "Clients",
    "users": "Users",
    "sapImport": "SAP Import",
    "deadLetters": "Dead Letters",
    "settings": "Settings",
    "noAccess": "No Access",
    "workflow": "Workflow"
  },
  "sapImport": {
    "title": "SAP Import",
    "description": "Overview of imported data from SAP.",
    "table": {
      "fileName": "File Name",
      "created": "Created",
      "size": "Size",
      "actions": "Actions",
      "showing": "Showing",
      "of": "of",
      "loading": "Loading...",
      "search": "Search by file name"
    },
    "actions": {
      "preview": "Preview",
      "download": "Download",
      "validate": "Validate"
    },
    "preview": {
      "title": "JSON Preview",
      "copyRaw": "Copy Raw JSON",
      "copied": "Copied",
      "search": "Search in JSON",
      "matchCount": "{current} of {total}",
      "noMatches": "No matches",
      "expandAll": "Expand all",
      "collapseAll": "Collapse all"
    },
    "empty": {
      "title": "No files found",
      "description": "There are no imported SAP files yet."
    },
    "error": {
      "loadFailed": "Failed to load SAP files.",
      "previewFailed": "Failed to load file preview.",
      "downloadFailed": "Failed to download file."
    },
    "validation": {
      "valid": "File is valid",
      "modalTitle": "Validation Errors",
      "errorCount": "{count} error(s)",
      "field": "Field",
      "errorCode": "Error Code",
      "errorMessage": "Message",
      "notFound": "File not found",
      "unavailable": "Validation is currently unavailable",
      "failed": "Validation failed"
    }
  },
  "deadLetters": {
    "filters": {
      "messageType": "Message type",
      "exceptionType": "Exception type",
      "exceptionMessage": "Exception message",
      "clear": "Clear filters"
    },
    "table": {
      "showing": "Showing",
      "of": "of",
      "loading": "Loading...",
      "messageType": "Message Type",
      "exceptionType": "Exception",
      "exceptionMessage": "Exception Message",
      "sentAt": "Sent At",
      "replayable": "Replayable",
      "actions": "Actions"
    },
    "actions": {
      "replay": "Replay",
      "delete": "Delete",
      "clearSelection": "Clear selection",
      "replayOne": "Replay this message",
      "deleteOne": "Delete this message",
      "selected": "selected"
    },
    "confirm": {
      "replayTitle": "Replay messages",
      "replayMessage": "Are you sure you want to replay {count} message(s)? They will be re-queued for processing.",
      "deleteTitle": "Delete messages",
      "deleteMessage": "Are you sure you want to permanently delete {count} message(s)? This cannot be undone.",
      "deleteSingleMessage": "Are you sure you want to permanently delete this message? This cannot be undone."
    },
    "notification": {
      "replayed": "Messages queued for replay successfully.",
      "deleted": "Messages deleted successfully.",
      "replayFailed": "Failed to replay messages.",
      "deleteFailed": "Failed to delete messages."
    },
    "empty": {
      "title": "No dead letters found",
      "description": "All messages are processing normally."
    },
    "badge": {
      "yes": "Yes",
      "no": "No"
    }
  },
  "userMenu": {
    "settings": "Settings",
    "appearance": {
      "label": "Appearance",
      "modes": {
        "light": "Light",
        "dark": "Dark"
      }
    },
    "auth": {
      "login": "Log in",
      "logout": "Log out",
      "notLoggedIn": "Not logged in"
    }
  },
  "notification": {
    "quotationInformationNoChanges": "No changes were found",
    "quotationInformationSaveSuccessfully": "Quotation information saved successfully",
    "quotationInformationSaveFailed": "Failed to save quotation information",
    "deliveryInformationSaveSuccessfully": "Delivery information saved successfully",
    "deliveryInformationSaveFailed": "Failed to save delivery information",
    "handoverInformationSaveSuccessfully": "Handover information saved successfully",
    "handoverInformationSaveFailed": "Failed to save handover information",
    "quotationApprovedSuccessfully": "Quotation has been approved",
    "orderApprovedSuccessfully": "Order has been approved",
    "deliveryApprovedSuccessfully": "Delivery has been approved",
    "quotationRejectedSuccessfully": "Quotation has been rejected",
    "orderRejectedSuccessfully": "Order has been rejected",
    "changesSaveSuccessfully": "Changes have been saved successfully",
    "changesSaveFailed": "Failed to save changes",
    "requestedDeliveryDateValidationError": "Requested delivery date is a required field",
    "tyreDeliveryConfirmedSuccessfully": "Tyre delivery has been confirmed",
    "notRegisteredUserApprovalLinkResent": "Approval link has been resent to {emails}",
    "notRegisteredUserApprovalLinkNoExpired": "No expired approval links found to resend",
    "notRegisteredUserApprovalLinkResendFailed": "Failed to resend approval link",
    "rejectFailed": "Failed to reject workflow",
    "quotationRestartedSuccessfully": "Quotation has been restarted",
    "workflowUnparkedSuccessfully": "Workflow has been resumed",
    "orderRestartedSuccessfully": "Order has been restarted",
    "restartFailed": "Failed to restart workflow"
  },
  "dashboard": {
    "searchPlaceholder": "Search by ext. reference or description",
    "requiringAction": {
      "title": "Requiring Your Action",
      "viewAll": "View All",
      "client": "Client",
      "supplier": "Supplier",
      "created": "Created",
      "approveMessage": "Please approve or reject quotation to proceed with the order.",
      "openDetail": "Open detail"
    },
    "empty": {
      "title": "No assigned tasks",
      "description": "There are currently no workflows awaiting your action.",
      "viewAll": "View all workflows"
    }
  },
  "workflows": {
    "table": {
      "showing": "Showing",
      "of": "of",
      "loading": "Loading...",
      "columns": {
        "externalReference": "Ext. Reference",
        "status": "Status",
        "delivery": "Delivery",
        "client": "Client",
        "driver": "Driver",
        "description": "Description",
        "supplier": "Supplier",
        "manufacturer": "Manufacturer",
        "model": "Model",
        "vehicle": "Vehicle",
        "assignees": "Assignees"
      },
      "filters": {
        "externalReference": "Filter Ext. Reference",
        "status": "Filter Status",
        "client": "Filter Client",
        "driver": "Filter Driver",
        "description": "Filter Description",
        "supplier": "Filter Supplier",
        "manufacturer": "Filter Manufacturer",
        "model": "Filter Model",
        "vehicle": "Filter Vehicle",
        "assignee": "Filter Assignee",
        "dateRange": "Select date range",
        "clearDateFilter": "Clear Date Filter",
        "clear": "Clear"
      },
      "dateFilters": {
        "allDates": "All Dates",
        "today": "Today",
        "thisWeek": "This Week",
        "thisMonth": "This Month",
        "thisYear": "This Year",
        "customRange": "Custom Range"
      },
      "multipleSuppliers": "Multiple Suppliers"
    },
    "assignedFilter": {
      "allWorkflows": "All workflows",
      "assignedToMe": "Assigned to me"
    }
  },
  "workflowDetail": {
    "header": {
      "detail": "Detail",
      "objectNumber": "Object number",
      "purchaseOrderNumber": "Purchase order number",
      "calculationNumber": "Calculation number",
      "quotationNumber": "Quotation number",
      "updatedVersionTooltip": "Updated version (v{version})",
      "downloadCalculation": "Download calculation",
      "downloadPurchaseOrder": "Download purchase order",
      "pdf": "PDF",
      "registrationProxy": "PDF",
      "downloadRegistrationProxy": "Download proxy for registration",
      "pdfNotFound": "Document not found.",
      "pdfDownloadError": "Failed to download document.",
      "reject": "Reject",
      "restart": "Restart",
      "viewQuotationData": "View original quotation data"
    },
    "actions": {
      "cancel": "Cancel",
      "save": "Save",
      "edit": "Edit",
      "unsavedChangesTitle": "Unsaved changes",
      "unsavedChangesMessage": "You have unsaved changes. Do you want to discard them?",
      "discard": "Discard",
      "continueEditing": "Continue editing"
    },
    "common": {
      "yes": "Yes",
      "no": "No",
      "select": "Select",
      "exclVat": "excl. VAT",
      "inclVat": "incl. VAT",
      "months": "Months",
      "annual": "Annual",
      "total": "Total"
    },
    "tabs": {
      "overview": "Overview",
      "additionalInformation": "Additional Information",
      "documents": "Documents",
      "notes": "Notes",
      "eventHistory": "Event History"
    },
    "overview": {
      "investmentPrice": "Investment price",
      "monthlyPayment": "Monthly payment",
      "contractSectionTitle": "Contract & delivery",
      "tyreSectionTitle": "Tyres",
      "vehicleSectionTitle": "Vehicle"
    },
    "meaningDeliveryDate": {
      "asap": "ASAP",
      "onDate": "On Date (EQ)",
      "afterDate": "After Date (GE)",
      "beforeDate": "Before Date (LE)"
    },
    "vehicle": {
      "vin": "VIN",
      "make": "Make",
      "makeName": "Make Name",
      "code": "Code",
      "model": "Model",
      "modelName": "Model Name",
      "enginePower": "Engine Power",
      "upholstery": "Upholstery",
      "color": "Color",
      "material": "Material",
      "homologation": "Homologation",
      "wheelCount": "Wheel count",
      "seats": "Seats",
      "co2Emissions": "CO₂ Emissions",
      "category": "Category",
      "exterior": "Exterior"
    },
    "tyreSpec": {
      "title": "Tyre Specification",
      "dimensions": "Dimensions",
      "type": "Type",
      "width": "Width",
      "profile": "Profile",
      "diameter": "Diameter",
      "speedIndex": "Speed Index",
      "loadIndex": "Load Index",
      "rimSensor": "RIM Sensor (TPMS)",
      "quantity": "Quantity",
      "pcs": "pcs",
      "pricing": "Pricing",
      "listPrice": "List Price",
      "discount": "Discount",
      "netPrice": "Net Price",
      "perPiece": "per piece",
      "total": "Total",
      "typeSummer": "Summer",
      "typeWinter": "Winter",
      "typeWinterStudded": "Winter Studded",
      "typeAllSeason": "All Season"
    },
    "tyrePackage": {
      "title": "Tyre Package",
      "priceAfterDiscount": "Price after Discount",
      "total": "Total",
      "discount": "Discount",
      "tyresTitle": "Tyres",
      "rimsTitle": "Rims",
      "tpmsTitle": "TPMS",
      "description": "Description",
      "dimensions": "Dimensions",
      "diameter": "Diameter",
      "type": "Type",
      "brand": "Brand",
      "quantity": "Qty",
      "code": "Code"
    },
    "contract": {
      "product": "Product",
      "financialProduct": "Financial Product",
      "commercialProduct": "Commercial Product",
      "duration": "Duration",
      "mileage": "Mileage",
      "externalReference": "External Reference",
      "createdDate": "Created Date",
      "quotationValidTo": "Validity Date",
      "requestForRegistration": "Request for registration",
      "driverSetReceipt": "Driver Set Receipt",
      "techCertificateSend": "Tech Certificate Send",
      "dealerExpectedDeliveryDate": "Expected delivery date",
      "meaningOfReqDeliveryDate": "Meaning of req. delivery date",
      "requiredDeliveryDate": "Required delivery date",
      "possibleDeliveryDate": "Possible delivery date",
      "registrationNumber": "Registration number",
      "dealerOrderId": "Dealer's order ID",
      "initialQuotationNumber": "Initial quotation number",
      "handoverDate": "Handover date",
      "registrationDate": "Registration date",
      "handoverMileage": "Handover mileage",
      "initialMileage": "Initial mileage",
      "stockDealer": "Stock - Dealer",
      "arrivedAtDealer": "Arrived at Dealer",
      "poolCar": "Pool car",
      "replacedCarRegNumber": "Replaced car reg. number",
      "replacedCarContractEnd": "Replaced car contract end",
      "secondTyreSetStorageAddress": "Tyre storage location",
      "secondTyreSetStorageDate": "Tyre storage date"
    },
    "driver": {
      "title": "Driver",
      "id": "ID",
      "name": "Name",
      "phone": "Phone",
      "email": "Email",
      "staffId": "Staff ID",
      "selectDriver": "Select Driver",
      "serviceUnavailable": "Service unavailable",
      "carBenefitLevel": "Car Benefit Level",
      "fullBenefitValue": "Full Benefit Value",
      "limitedBenefitValue": "Limited Benefit Value",
      "benefitLevels": {
        "limited": "Limited Benefit",
        "full": "Full Benefit"
      }
    },
    "contactForVehicle": {
      "title": "Contact for Vehicle",
      "id": "ID",
      "name": "Name",
      "phone": "Phone",
      "email": "Email",
      "serviceUnavailable": "Service unavailable"
    },
    "client": {
      "title": "Client",
      "name": "Name",
      "id": "ID",
      "contractNumber": "Contract number",
      "costCentreNumber": "Cost centre number",
      "costCentre": "Cost centre",
      "serviceUnavailable": "Service unavailable"
    },
    "supplier": {
      "title": "Supplier",
      "name": "Name",
      "id": "ID",
      "address": "Address",
      "email": "Email",
      "phone": "Phone",
      "salesPerson": "Sales person",
      "usingEOrders": "Uses eOrders",
      "notUsingEOrders": "Does not use eOrders",
      "addEmailAddress": "Add Email Address"
    },
    "purchaseOrderType": {
      "vehicle": "Vehicle",
      "tyre": "Tyre"
    }
  },
  "additionalInfo": {
    "fuelCards": {
      "title": "Fuel Cards",
      "cardType": "Card Type",
      "orderConfirmed": "Order Confirmed",
      "validFrom": "Valid From",
      "deliveryDate": "Delivery Date",
      "status": "Status",
      "noCardsAvailable": "No fuel cards available"
    },
    "services": {
      "title": "Services",
      "serviceCode": "Service Code",
      "serviceName": "Service Name",
      "specification": "Specification",
      "included": "Included",
      "monthlyRate": "Monthly Rate (excl. VAT)",
      "noServicesAvailable": "No services available"
    },
    "vehicle": {
      "title": "Vehicle",
      "description": "Vehicle Description",
      "deliveryCost": "Delivery cost",
      "registrationTax": "Vehicle registration tax",
      "registrationCost": "Registration cost"
    },
    "accessories": {
      "title": "Accessories & Options",
      "titleAccessoriesOnly": "Accessories",
      "seqNumber": "#",
      "code": "Code",
      "description": "Accessory Description",
      "standard": "Standard",
      "manufacturer": "Manufacturer",
      "price": "Price",
      "afterDiscount": "After Discount (excl. VAT)",
      "discount": "Discount",
      "owner": "Owner",
      "noAccessoriesAvailable": "No accessories available"
    },
    "options": {
      "title": "Options",
      "description": "Option Description",
      "total": "Options total",
      "registrationTax": "Registration tax for options",
      "noOptionsAvailable": "No options available"
    },
    "tyres": {
      "title": "Tyres",
      "position": "Position",
      "manufacturer": "Manufacturer",
      "dimensions": "Dimensions",
      "loadIndex": "Load Index",
      "speedIndex": "Speed Index",
      "season": "Season",
      "price": "Price",
      "noTyresAvailable": "No tyres available"
    },
    "mileageRates": {
      "title": "Mileage Rates",
      "baseRate": "Base Rate",
      "mvaLess": "Below-limit Kilometers",
      "mvaMore": "Above-limit Kilometers",
      "noMileageRatesAvailable": "No Mileage Rates Available"
    }
  },
  "processStatus": {
    "categories": {
      "statusWithStep": "Status - step",
      "statusOnly": "Status only"
    },
    "status": {
      "quotationApproval": "Quotation Approval",
      "orderApproval": "Order Approval",
      "orderProcessing": "Order Processing",
      "orderUpdated": "Order Updated",
      "delivery": "Delivery",
      "quotationRejected": "Quotation Rejected",
      "orderRejected": "Order Rejected",
      "completed": "Completed",
      "archived": "Archived"
    },
    "step": {
      "quotationApproval": {
        "notDefined": "Not defined",
        "schemaFinalization": "Schema finalization",
        "parked": "Parked",
        "driverApproval": "Pending driver approval",
        "clientApproval": "Pending client approval",
        "hRApproval": "Pending HR approval",
        "fleetManagerApproval": "Pending FleetManager approval",
        "supervisorApproval": "Pending supervisor approval",
        "groupApproval": "Pending group approval",
        "personApproval": "Pending person approval",
        "notRegisteredUserApproval": "Not registered user approval",
        "purchaseSupportApproval": "Pending Purchase Support approval",
        "clientAccountAcceptation": "Pending CA approval",
        "orderCreation": "Order creation",
        "completed": "Completed"
      },
      "quotationRejected": {
        "rejection": "Rejection",
        "rejected": "Rejected"
      },
      "delivery": {
        "parked": "Parked",
        "notDefined": "Not defined",
        "notActive": "Not active",
        "waiting": "Waiting",
        "vehicleRegistration": "Vehicle Registration",
        "handoverPreparation": "Handover Preparation",
        "handover": "Ready for handover",
        "delivered": "Delivered",
        "completed": "Completed"
      },
      "orderApproval": {
        "parked": "Parked",
        "kamApproval": "KAM Approval",
        "oDApproval": "OD Approval",
        "deliveryConfirmation": "Delivery Confirmation",
        "supplierAcceptation": "Supplier Acceptation",
        "supplierApproval": "Supplier Approval",
        "dealerAcceptation": "Dealer Acceptation",
        "dealerConfirmation": "Dealer Confirmation",
        "dealerRejectionConfirmation": "Rejection confirmed by dealer",
        "dealerRejection": "Rejected by dealer",
        "delivered": "Delivered",
        "notDefined": "Not defined",
        "rejection": "Rejection",
        "rejected": "Rejected",
        "completed": "Completed"
      },
      "orderProcessing": {
        "parked": "Parked",
        "waiting": "Waiting",
        "supplierAcceptation": "Supplier Acceptation",
        "deliveryConfirmation": "Delivery Confirmation",
        "delivered": "Delivered",
        "completed": "Completed"
      },
      "orderUpdated": {
        "parked": "Parked",
        "waiting": "Waiting",
        "completed": "Completed"
      },
      "orderRejected": {
        "notDefined": "Not defined",
        "dealerRejection": "Rejected by dealer",
        "dealerRejectionConfirmation": "Rejection confirmed by dealer",
        "supplierAcceptation": "Supplier Acceptation",
        "supplierApproval": "Supplier Approval",
        "rejection": "Rejection",
        "rejected": "Rejected"
      },
      "completed": {
        "delivered": "Delivered",
        "completed": "Completed"
      }
    },
    "combined": {
      "quotationSchemaFinalization": "Quotation - Schema finalization",
      "quotationParked": "Quotation - Parked",
      "orderApprovalParked": "Order Approval - Parked",
      "orderProcessingParked": "Order Processing - Parked",
      "orderUpdatedParked": "Order Updated - Parked",
      "deliveryParked": "Delivery - Parked",
      "quotationApprovals": "Quotation - Approvals",
      "quotationClientApproval": "Quotation - Pending client approval",
      "quotationClientAccountAcceptation": "Quotation - Pending CA approval",
      "quotationOrderCreation": "Quotation - Order creation",
      "orderKamApproval": "Order - KAM Approval",
      "orderOdApproval": "Order - OD Approval",
      "orderDealerAcceptation": "Order - Dealer Acceptation",
      "orderDealerConfirmation": "Order - Dealer Confirmation",
      "orderProcessingWaiting": "Order Processing - Waiting",
      "orderUpdatedWaiting": "Order Updated - Waiting",
      "deliveryVehicleRegistration": "Delivery - Vehicle Registration",
      "deliveryHandoverPreparation": "Delivery - Handover Preparation",
      "deliveryHandover": "Delivery - Handover",
      "tyreSupplierApproval": "Tyre - Supplier Approval",
      "tyreSupplierAcceptation": "Tyre - Supplier Acceptation",
      "tyreDeliveryConfirmation": "Tyre - Delivery Confirmation",
      "tyreDelivered": "Tyre - Delivered"
    },
    "actions": {
      "approve": "Approve",
      "reject": "Reject",
      "submit": "Submit",
      "save": "Save"
    },
    "manageApprovalFlow": "Manage Approval Flow",
    "rejectReasonLabel": "Please provide a reason for rejection",
    "rejectReasonPlaceholder": "Type your reason...",
    "rejectReasonRequired": "Rejection reason is required",
    "actionRequiredQuotationSchemaFinalization": "Action Required: Please approve or reject quotation to proceed with the order.",
    "actionRequiredQuotationParked": "This workflow is parked. Choose how to resume it.",
    "actionRequiredQuotationParkedWithOrders": "Workflow parked. Choose how to resume - you'll then decide for each purchase order.",
    "actionRequiredOrderParked": "The original order is parked. Choose how to handle it.",
    "orderUnpark": {
      "restart": "Restart new order version",
      "noRestart": "Resume without new updated order"
    },
    "unpark": {
      "restartFromQuotation": "Restart client approval",
      "restartFromPurchaseOrder": "Restart from purchase order",
      "noRestart": "Resume without restart"
    },
    "actionRequiredQuotationDriverApproval": "Action Required: Please approve or reject quotation to proceed with the order.",
    "actionRequiredQuotationHRApproval": "Action Required: Please approve or reject quotation to proceed with the order.",
    "actionRequiredQuotationFleetManagerApproval": "Action Required: Please approve or reject quotation to proceed with the order.",
    "actionRequiredQuotationClientApproval": "Action Required: Please approve or reject quotation to proceed with the order.",
    "actionRequiredQuotationSupervisorApproval": "Action Required: Please approve or reject quotation to proceed with the order.",
    "actionRequiredQuotationGroupApproval": "Action Required: Please approve or reject quotation to proceed with the order.",
    "actionRequiredQuotationPersonApproval": "Action Required: Please approve or reject quotation to proceed with the order.",
    "actionRequiredQuotationPurchaseSupportApproval": "Action Required: Please approve or reject quotation to proceed with the order.",
    "actionRequiredQuotationClientAdjustment": "Action Required: Please complete and review fields below. Once filled, the quotation can be approved by ClientAccount.",
    "actionRequiredQuotationClientAccountAcceptation": "Confirmation Required: Please enter the quotation number, then approve or reject the offer.",
    "actionRequiredQuotationRejection": "Action Required: Quotation has been rejected. Please confirm to finalize the rejection.",
    "actionRequiredVehicleOrderStepKamApproval": "Action Required: Please approve or reject order to proceed.",
    "actionRequiredVehicleOrderStepODApproval": "Action Required: Please check supplier below and approve or reject order to proceed.",
    "actionRequiredVehicleOrderStepDealerAcceptation": "Action Required: Please approve or reject the order to proceed.",
    "actionRequiredVehicleOrderStepDealerConfirmation": "Action Required: Please enter the estimated delivery date and approve or reject the order.",
    "actionRequiredVehicleOrderStepDealerRejectionConfirmation": "Action Required: Please confirm the order rejection.",
    "actionRequiredVehicleOrderStepDealerRejection": "Action Required: Dealer has rejected this order. Please confirm to finalize the rejection.",
    "actionRequiredDeliveryStepWaiting": "Action Required: Please fill in all the necessary fields below.",
    "actionRequiredDeliveryStepVehicleRegistration": "Action Required: Please check or enter the license plate number and registration date.",
    "actionRequiredDeliveryStepHandoverPreparation": "Action Required: Please confirm that the vehicle handover notification has been sent.",
    "actionRequiredDeliveryStepHandover": "Action Required: Please enter or confirm the vehicle handover date and mileage.",
    "selectDriver": "Select Driver",
    "replacedCarRegNumber": "Replaced car reg. number",
    "meaningOfReqDeliveryDate": "Meaning of req. delivery date",
    "requiredDeliveryDate": "Required delivery date",
    "possibleDeliveryDate": "Possible delivery date",
    "vin": "VIN",
    "co2Emissions": "CO₂ Emissions",
    "registrationNumber": "Registration number",
    "registrationDate": "Registration date",
    "socialSecurityNumber": "Social security number",
    "initialQuotationNumber": "Initial quotation number",
    "dealerExpectedDeliveryDate": "Expected delivery date",
    "expectedDeliveryDateInvalidTitle": "Invalid expected delivery date.",
    "expectedDeliveryDateInvalidMessage": "Expected Delivery Date must be higher than the Possible delivery date and minimum seven work days from today.",
    "registrationDateMustBeTodayMessage": "Registration date must be equal to the current date.",
    "handoverDate": "Handover date",
    "handoverMileage": "Handover mileage",
    "initialMileage": "Initial mileage",
    "actionRequiredTyreOrderStepSupplierApproval": "Action Required: Please approve or reject the tyre order to proceed.",
    "actionRequiredTyreOrderStepSupplierAcceptation": "Action Required: Please approve or reject the tyre order to proceed.",
    "actionRequiredTyreOrderStepDeliveryConfirmation": "Action Required: Please confirm delivery and optionally enter tyre set delivery info.",
    "actionRequiredTyreOrderStepRejection": "Action Required: Supplier has rejected this tyre order. Please confirm to finalize the rejection.",
    "secondTyreSetDeliveryInfo": "Please write here an info of where the second tyre set was delivered",
    "secondTyreSetDeliveryDate": "Delivery date",
    "actionRequiredQuotationNotRegisteredUserApproval": "Action Required: Please approve or reject quotation to proceed with the order.",
    "resendNotRegisteredUserApprovalLink": "Resend Approval Link"
  },
  "workflow": {
    "approval": {
      "title": "Workflow Approval Flow",
      "description": "Manage approval steps for this workflow",
      "workflowId": "Workflow ID",
      "loading": "Loading approval flow...",
      "addStep": "Add step",
      "stepTypePlaceholder": "Select step type",
      "step": "Step",
      "supervisorEmail": "Supervisor email",
      "notRegisteredUserEmail": "Not Registered User email",
      "notRegisteredUserEmailRequired": "Please enter an email address for this step.",
      "supervisorEmailRequired": "Please enter a supervisor email address for this step.",
      "personPlaceholder": "Select person...",
      "personRequired": "Please select a user for this step.",
      "noEmployeesFound": "No registered employees found for this client.",
      "groupPlaceholder": "Select group path...",
      "groupRequired": "Please select a group path for this step.",
      "stepTypeRequired": "Select a type for every step to continue.",
      "empty": "No custom approval steps defined. After saving, the default PurchaseSupport Approval step will be used.",
      "addFirstStep": "Add custom step",
      "saveWorkflowAndClient": "Save & set as client default",
      "saveWorkflowAndClientShort": "Save & default",
      "save": "Save for this quotation",
      "saveShort": "Save",
      "close": "Close",
      "error": "Unable to load workflow approval flow.",
      "saveSuccess": "Approval flow saved successfully.",
      "saveError": "Unable to save approval flow.",
      "clientSaveSuccess": "Client approval flow saved successfully.",
      "clientSaveError": "Unable to save client approval flow.",
      "stepTypes": {
        "driverApprovalStep": "Driver Approval",
        "hrApprovalStep": "HR Approval",
        "fleetManagerApprovalStep": "FleetManager Approval",
        "purchaseSupportApprovalStep": "PurchaseSupport Approval",
        "supervisorApprovalStep": "Supervisor Approval",
        "notRegisteredUserApprovalStep": "Not Registered User Approval",
        "groupApprovalStep": "Group Approval",
        "personApprovalStep": "Person Approval"
      }
    }
  },
  "notes": {
    "addNewNote": "Add new note",
    "placeholderText": "Write your note...",
    "submitNote": "Submit note",
    "noNotesYet": "No notes yet",
    "noteAddedSuccessfully": "Note added successfully",
    "failedToAddNote": "Failed to add note"
  },
  "clients": {
    "table": {
      "showing": "Showing",
      "of": "of",
      "loading": "Loading...",
      "columns": {
        "id": "ID",
        "name": "Name"
      },
      "search": {
        "global": "Search by ID or client name"
      }
    },
    "detail": {
      "title": "Client detail",
      "description": "Approval flow overview",
      "clientId": "Client ID",
      "loading": "Loading approval flow...",
      "addStep": "Add step",
      "stepTypePlaceholder": "Select step type",
      "step": "Step",
      "supervisorEmail": "Supervisor email",
      "notRegisteredUserEmail": "Not Registered User email",
      "personPlaceholder": "Select person...",
      "personRequired": "Please select a user for this step.",
      "noEmployeesFound": "No registered employees found for this client.",
      "groupPlaceholder": "Select group path...",
      "groupRequired": "Please select a group path for this step.",
      "stepTypeRequired": "Select a type for every step to continue.",
      "empty": "No custom approval steps defined. After saving, the default PurchaseSupport Approval step will be used.",
      "createFlow": "Create custom flow",
      "addFirstStep": "Add custom step",
      "applyDefaultFlow": "Use default approval flow",
      "save": "Save",
      "close": "Close",
      "order": "Order",
      "role": "Role",
      "group": "Group",
      "error": "Unable to load client detail.",
      "stepDescriptionFallback": "Custom approval step",
      "defaultApplied": "Default approval flow applied.",
      "defaultApplyError": "Unable to apply default approval flow.",
      "customFlowCreated": "Custom approval flow created.",
      "customFlowCreateError": "Unable to create a new approval flow.",
      "saveSuccess": "Approval flow saved successfully.",
      "saveError": "Unable to save approval flow.",
      "stepTypes": {
        "driverApprovalStep": "Driver Approval",
        "hrApprovalStep": "HR Approval",
        "fleetManagerApprovalStep": "FleetManager Approval",
        "purchaseSupportApprovalStep": "PurchaseSupport Approval",
        "supervisorApprovalStep": "Supervisor Approval",
        "notRegisteredUserApprovalStep": "Not Registered User Approval",
        "groupApprovalStep": "Group Approval",
        "personApprovalStep": "Person Approval"
      },
      "notice": {
        "custom": "This client uses a custom approval flow.",
        "default": "This client currently uses the default approval flow (Purchase Support Approval).",
        "empty": "Custom approval flow is empty. After saving, the default PurchaseSupport Approval step will be automatically applied."
      }
    }
  },
  "documents": {
    "noDocumentsFound": "No Documents Found",
    "uploadHint": "You can upload a document.",
    "uploadSuccess": "File(s) uploaded successfully",
    "uploadError": "Failed to upload file(s)",
    "downloadError": "Failed to download document."
  },
  "fileUpload": {
    "dragAndDrop": "Drop files or <span class=\"text-primary\">click to browse</span>",
    "upload": "Upload {count} file(s)",
    "removeFile": "Remove file",
    "maxFilesExceeded": "Cannot select more than {max} files at once.",
    "fileSizeHint": "Maximum file size is {maxSize}&nbsp;MB. Allowed types: {allowedTypes}.",
    "fileSizeExceeded": "File {fileName} exceeds maximum size of {maxSize} MB.",
    "fileTypeNotSupported": "File {fileName} has unsupported type. Allowed types: {allowedTypes}."
  },
  "eventHistory": {
    "noRecords": "No history records found"
  },
  "workflowPublic": {
    "protectedAccess": "Protected Access",
    "description": "This workflow detail is password protected.",
    "requestCodeDescription": "To view this workflow, please request an access code. It will be sent to the email address associated with this workflow.",
    "sendAccessCode": "Send Access Code",
    "enterCode": "Enter Code",
    "codeSentDescription": "Please enter the 6-digit code sent to your email.",
    "verifyAccess": "Verify Access",
    "resendCode": "Resend Code",
    "resendIn": "Resend in {seconds}s",
    "resendLimitReached": "Maximum resend attempts reached",
    "codeSent": "Access code sent to your email",
    "codeResent": "A new access code has been sent to your email",
    "verified": "Authenticated successfully",
    "approved": "Approval submitted successfully",
    "retryIn": "Try again in {minutes} minutes",
    "tryAgain": "Try Again",
    "errors": {
      "expired": "This approval link has expired. Please request a new one.",
      "invalidCode": "The code you entered is invalid or has expired. Please request a new code and try again.",
      "rateLimited": "Too many attempts. Please wait before trying again.",
      "sessionExpired": "Your session has expired. Please start over.",
      "forbidden": "You are not authorized to perform this action.",
      "serverError": "Something went wrong. Please try again later."
    },
    "errorTitles": {
      "expired": "Link Expired",
      "invalidCode": "Invalid or Expired Code",
      "rateLimited": "Too Many Attempts",
      "unauthorized": "Session Expired",
      "serverError": "Server Error"
    }
  },
  "rejectModal": {
    "title": "Reject Workflow",
    "reasonLabel": "Rejection Reason",
    "reasonPlaceholder": "Please provide a reason for rejection...",
    "initiatorLabel": "Rejection Initiator",
    "initiatorPlaceholder": "Select who initiated the rejection...",
    "initiatorSupplier": "Supplier",
    "initiatorClient": "Client",
    "cancel": "Cancel",
    "confirm": "Reject"
  },
  "noAccess": {
    "title": "Access Denied",
    "description": "You do not have permission to view this page. Please contact your administrator if you believe this is an error.",
    "backHome": "Back to Home"
  },
  "error": {
    "loadingData": "Failed to load data.",
    "apiDown": "The server is not responding. Please try again later."
  }
}